import React from "react"
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import Typography from "@mui/material/Typography";
import "../../../utility/i18n"
import CCOLoadableContainer from "../../fundamentals/CCOLoadableContainer";
import DownloadIcon from '@mui/icons-material/Download';
import {bytesToSize, generateDownloadUrl} from "../../../utility/navigationUtil";
import {metaDataElementWithId, metaDataProperty} from "../../preview/previewMetaData";
import {usePreviewContext} from "../../../context/PreviewContext";
import {getDataType} from "../../../utility/componentUtil";
import {CmCollectionType, CmDownloadType} from "../../types";
import {createLinkClickHandler} from "src/tracking/handlers/linkClickHandler";

interface Props {
    cmCollection: CmCollectionType
    hideBottomDivider?: boolean
}

function DownloadItems(props: Props) {
    const isPreview = usePreviewContext().isPreview;
    return (
        <CCOLoadableContainer cmCollection={props.cmCollection}
                              maxItemDisplayed={(props.cmCollection as any).downloadSettings?.downloadDesktop}
                              showMoreCount={(props.cmCollection as any).downloadSettings?.showMoreCount
                                             ??
                                             (props.cmCollection as any).downloadSettings?.downloadDesktop}>
            <React.Fragment>
                <List sx={{width: '100%', bgcolor: 'background.paper'}}>
                    {props.cmCollection.items?.map(i => i as CmDownloadType).map(
                        (item: CmDownloadType, index: number) => {
                            const downloadHref = generateDownloadUrl(item.id ?? '',
                                                                     item.title ?? '');
                            return (
                                <Container key={index} {...metaDataElementWithId(isPreview,
                                                                                        item.id)}>
                                    {index === 0 ? null : <Divider/>}
                                    <ListItem id={item.id} alignItems="flex-start"
                                              sx={{minHeight: 85}}>
                                        <ListItemButton
                                            component="a"
                                            data-cypress={'downloadLink'}
                                            id={"download-" + item.id}
                                            href={downloadHref}
                                            target="_blank"
                                            onClick={createLinkClickHandler({
                                                                                href: downloadHref,
                                                                                linkTarget: "_blank"
                                                                            })}
                                            sx={{
                                                minHeight: 69, paddingY: 0,
                                                textDecoration: 'none',
                                                '&:hover': {
                                                    '& .downloadIcon': {
                                                        backgroundColor: 'primary.dark',
                                                    },
                                                    '& span, h6': {
                                                        color: 'primary.main',
                                                    },
                                                    backgroundColor: 'primary.contrastText'
                                                },
                                            }}>
                                            <Box className="downloadIcon" aria-hidden="true"
                                                 sx={{
                                                     display: 'flex',
                                                     alignItems: 'center',
                                                     justifyContent: 'center',
                                                     borderRadius: '50%',
                                                     flexShrink: 0,
                                                     height: 50,
                                                     width: 50,
                                                     padding: 0,
                                                     marginRight: 6,
                                                     backgroundColor: "primary.main"
                                                 }}>
                                                <DownloadIcon
                                                    sx={{
                                                        color: "primary.contrastText",
                                                        padding: 0,
                                                        'path':
                                                            {
                                                                height: '48!important'
                                                            }
                                                    }}/>
                                            </Box>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    minWidth: 0,
                                                    hyphens: 'auto',
                                                    overflowWrap: 'break-word'
                                                }}>
                                                <Typography
                                                    variant={'accordion'}
                                                    {...metaDataProperty(isPreview,
                                                                         'properties.title',
                                                                         item.id)}
                                                    sx={{
                                                        color: 'text.primary'
                                                    }}>{item.title}</Typography>
                                                <Typography variant={'subtitle2'}
                                                            sx={{
                                                                color: 'text.primary'
                                                            }}>{getDataType(
                                                                                        item.data?.contentType ?? '') + " ("
                                                                                    + bytesToSize(
                                                        item.data?.size || 0).replace('.',
                                                                                      ',')})</Typography>
                                            </Box>

                                        </ListItemButton>
                                    </ListItem>
                                    <Divider/>
                                </Container>
                            );
                        }
                    )}
                </List>
            </React.Fragment>
        </CCOLoadableContainer>
    );
}


export default DownloadItems
